// VITE_WEBSITE_LINK may or may not end in "/", so paths are joined here.
const APP_URL = (import.meta.env.VITE_WEBSITE_LINK || "").replace(/\/+$/, "");

export const LOGIN_URL = `${APP_URL}/login`;
export const APPLICATION_URL = `${APP_URL}/register`;
export const APPLY_NOW_PATH = "/apply-now";
